import { render, staticRenderFns } from "./ExternalSorting.vue?vue&type=template&id=9c7a8ec6&"
import script from "./ExternalSorting.vue?vue&type=script&lang=js&"
export * from "./ExternalSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports